export default "__VITE_ASSET__03fdd2ff__"